// extracted by mini-css-extract-plugin
export default {"box":"refundDetailPage_box__cPufE","box__order__detail":"refundDetailPage_box__order__detail__3Esc6"};